import { getAuthContext } from '../context/AuthContext';

const getAxios = () => getAuthContext().axiosInstance;

export const DetalleVentaService = {
    getByVenta: async (idVenta) => {
        const response = await getAxios().get(`/api/detalle-ventas/venta/${idVenta}`);
        return response.data;
    },

    create: async (detalleVenta) => {
        const response = await getAxios().post('/api/detalle-ventas', detalleVenta);
        return response.data;
    },

    update: async (id, detalleVenta) => {
        const response = await getAxios().put(`/api/detalle-ventas/${id}`, detalleVenta);
        return response.data;
    },

    delete: async (id) => {
        const response = await getAxios().delete(`/api/detalle-ventas/${id}`);
        return response.data;
    },

    deleteByVenta: async (idVenta) => {
        const response = await getAxios().delete(`/api/detalle-ventas/venta/${idVenta}`);
        return response.data;
    }
};
